import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SubidaDocumentoSimpleComponent } from './subida-documento.simple';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SubidaDocumentoSimpleComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    SubidaDocumentoSimpleComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class SubidaDocumentoSimpleModule { }
